//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from "chart.js";
import {BTable} from 'bootstrap-vue';
import MissionDialog from "@/components/mission/MissionDialog";
import {insightService} from "@/insight-service";

export default {
  name: "PerformanceMetrics",
  components: {
    BTable, MissionDialog,
  },
  props: {
    model: {},
    output: String,
  },

  watch: {
    model() {
      this.loadMetrics();
    },
    output() {
      this.loadMetrics();
    },
    low() {
      this.filter();
    },
    high() {
      this.filter();
    },
    poor() {
      this.filter();
    },
    statusNew() {
      this.filter();
    },
  },

  mounted() {
    this.loadMetrics();
  },

  data: () => ({
    sortBy: 'values',
    sortDesc: false,
    fields: [
      {
        key: 'values',
        sortable: true
      },
      {
        key: 'perform',
        label: 'Performance',
        sortable: true,
        formatter: value => (value * 100).toFixed(2) + '%'
      },
      {
        key: 'sample',
        sortable: true
      },
      {
        key: 'train',
        sortable: true
      },
      {
        key: 'eval',
        label: 'Evaluation',
        sortable: true,
      },
      'mission'
    ],
    catFields: [
      {
        key: 'values',
        sortable: true
      },
      {
        key: 'perform',
        label: 'Performance',
        sortable: true,
        formatter: value => (value * 100).toFixed(2) + '%'
      },
      {
        key: 'sample',
        sortable: true
      },
      {
        key: 'train',
        sortable: true
      },
      {
        key: 'eval',
        label: 'Evaluation',
        sortable: true,
      },
      'status'
    ],
    outputs: [],
    categories: [],
    allCategories: [],
    displayCatTable: false,
    low: false,
    high: false,
    poor: false,
    statusNew: false,
    perPage: 20,
    paginationOptions: [20, 40],
    currentPage: 1,
    totalRows: 0,
    textFilter: "",
    showDialog: false,
    currentGraph: {},
    selectedOutput: undefined,
    displayChart: true,
    displayTable: true,
    selectedCategories: [],
  }),

  methods: {
    getLiveModel(model) {
      return insightService.getLiveModel(model);
    },
    getObject(array) {
      return Object.entries(array);
    },
    open(value) {
      this.selectedOutput = value;
      this.showDialog = true;
    },
    cancel() {
      this.selectedCategories = [];
      this.selectedOutput = undefined;
      this.showDialog = false;
    },
    loadMetrics() {
      if (!(this.model && this.model.contextParameters))
        return;
      window.setTimeout(() => {
        this.createChartPerformance();
      }, 100);
    },
    fillOutputTable(labels, measures, samples, trains, evals) {
      this.outputs = [];
      labels.forEach((label, key) => {
        this.outputs.push({
          values: label,
          perform: measures[key],
          sample: samples[key],
          train: trains[key],
          eval: evals[key],
          mission: 'action',
        })
      })
    },
    initCatTable(labels, measures, samples, trains, evals, matrix) {
      this.fillCatTable(labels, measures, samples, trains, evals, matrix);
      this.allCategories = this.categories;
    },
    fillCatTable(labels, measures, samples, trains, evals, matrix) {
      this.categories = [];
      labels.forEach((label, key) => {
        this.categories.push({
          values: label,
          perform: measures[key],
          sample: samples[key],
          train: trains[key],
          eval: evals[key],
          status: this.getStatus(measures[key], samples[key]),
          matrix: matrix[key],
        })
      })
      this.totalRows = this.categories.length;
    },
    filter() {
      let categories = this.allCategories;
      if (this.high) {
        categories = categories.filter((category) => category.perform >= 0.80);
      }
      if (this.low) {
        categories = categories.filter((category) => category.perform < 0.80);
      }
      if (this.poor) {
        categories = categories.filter((category) => category.sample < 50);
      }
      if (this.statusNew) {
        categories = this.getNewCat(categories);
      }
      this.categories = categories;
    },
    getNewCat(categories) {
      let hasVersion = false;
      const versions = this.model.contextParameters.versions.entries.filter(
          (version) => version.isVersion
      );
      if (versions.length !== 0) {
        versions.map((version) => {
          if (version.contextParameters.performance) {
            const categoriesFromVersion = version.contextParameters.performance.categories[`${this.output}`];
            const catFromVersionLabels = categoriesFromVersion.map((category) => category.name);
            categories = catFromVersionLabels.filter((versionCatLabel) => !categories.includes(versionCatLabel));
            hasVersion = true;
          }
        });
      }
      if (!hasVersion) {
        return [];
      }
      return categories;
    },
    getStatus(measure, samples) {
      let status = {}
      status.low = measure < 0.80;
      status.high = measure >= 0.80;
      status.new = false;
      status.poor = samples < 50;
      return status;
    },
    createChartPerformance() {
      this.displayChart = true;
      let labels, measures, samples, trains, evals = [];
      // Outputs
      if (!this.output || this.output === 'All') {
        const outputs = this.model.contextParameters.performance.outputs;
        labels = outputs.map((output) => output.name);
        measures = outputs.map((output) => output.measure);
        samples = outputs.map((output) => output.train + output.eval);
        trains = outputs.map((output) => output.train);
        evals = outputs.map((output) => output.eval);
        this.displayTable = true;
        this.displayCatTable = false;
        this.fillOutputTable(labels, measures, samples, trains, evals);
      } else {
        const output = this.model.contextParameters.performance.categories[`${this.output}`];
        labels = output.map((category) => category.name);
        measures = output.map((category) => category.measure);
        samples = output.map((category) => category.train + category.eval);
        trains = output.map((category) => category.train);
        evals = output.map((category) => category.eval);
        this.displayTable = false;
        // Categories
        let categories;
        // if (this.output === 'All') {
        //   categories = Object.values(this.model.contextParameters.performance.categories).flatMap((output) => output)
        // } else {
        categories = this.model.contextParameters.performance.categories[`${this.output}`];
        let catLabels, catMeasures, catSamples, catTrains, catEvals, catMatrix;
        catLabels = categories.map((category) => category.name);
        catMeasures = categories.map((category) => category.measure);
        catSamples = categories.map((category) => category.train + category.eval);
        catTrains = categories.map((category) => category.train);
        catEvals = categories.map((category) => category.eval);
        catMatrix = categories.map((category) => category['confusion_matrix']);
        this.displayCatTable = true;
        this.initCatTable(catLabels, catMeasures, catSamples, catTrains, catEvals, catMatrix);
      }
      // Radar charts
      if (labels.length < 3) {
        this.displayChart = false;
        return;
      }
      this.drawPerfChart(labels, measures, samples);
    },
    rowClass() {
      return 'cat-row';
    },
    drawPerfChart(labels, performance, samples) {
      // Normalization
      const samplesMax = Math.max(...samples);
      const sampleRates = samples.map((sample) => ((sample / samplesMax) * 100));
      const performanceRates = performance.map((perf) => perf * 100);
      const data = {
        labels: labels,
        datasets: [{
          label: 'Performance',
          backgroundColor: 'rgba(55,45,198,0.6)',
          data: performanceRates,
          pointBackgroundColor: '#D0C4F2',
        }, {
          label: 'Samples',
          backgroundColor: 'rgba(176,157,234,0.6)',
          data: sampleRates,
          pointBackgroundColor: '#EDE7FA',
        },
          {
            label: '',
            data: samples,
            hidden: true,
          }
        ],
      };
      Chart.defaults.global.legend.labels.usePointStyle = true;
      if (Object.keys(this.currentGraph).length !== 0) {
        this.currentGraph.destroy();
      }
      this.currentGraph = new Chart(this.$refs.chartPerf, {
        maintainAspectRatio: true,
        type: 'radar',
        data: data,
        options: {
          legendCallback: (chart) => {
            let text = [];
            text.push('<ul style="display:inline;margin-block-start: 0;padding-inline-start: 0;">');
            chart.data.datasets.forEach((dataset) => {
              text.push('<li style="display: inline; border-radius: 25px;\n' +
                  '  background: ' + dataset.pointBackgroundColor + ';\n' +
                  '  width: 110px;\n' +
                  '  padding: 10px;\n' +
                  '  margin-right: 10px;\n' +
                  '  cursor: pointer;\n' +
                  '  color: #372DC6;\n' +
                  '  height: 50px;"><span>');
              text.push(dataset.label);
              text.push('</span></li>');
            });
            text.push('</ul>');
            return text.join("");
          },
          responsive: true,
          maintainAspectRatio: true,
          hover: {
            mode: 'index'
          },
          legend: false,
          scale: {
            angleLines: {
              display: false
            },
            ticks: {
              suggestedMin: 50,
              suggestedMax: 100
            },
            pointLabels: {
              display: data.labels.length < 20
            }
          },
          tooltips: {
            callbacks: {
              "title": (tooltipItem, data) => data.labels[tooltipItem[0].index],
              "label": (tooltipItem, data) => {
                const label = data.datasets[tooltipItem.datasetIndex].label;
                const value = tooltipItem.datasetIndex === 0 ? parseFloat(tooltipItem.value).toFixed(2) + '%' : data.datasets[2].data[tooltipItem.index];
                return label + ' ' + value;
              }
            }
          }
        }
      });
      this.$refs.legends.innerHTML = this.currentGraph.generateLegend();
      Array.from(this.$refs.legends.children[0].children).forEach((li, index) => {
        li.addEventListener('click', () => {
          this.legendsToggle(li, index)
        });
      });
    },
    legendsToggle(li, index) {
      this.currentGraph.data.datasets[index].hidden = !this.currentGraph.data.datasets[index].hidden;
      this.currentGraph.update();
      if (!this.currentGraph.data.datasets[index].hidden) {
        li.style.opacity = '100%';
      } else {
        li.style.opacity = '50%';
      }
    }
  },
};
